import { StoryblokBanner } from './StoryblokBanner'

import { createBanner } from './__mocks__/banner'

export { createBanner }

// Re-export for backward compatibility
export const dummyBannerBlok = createBanner()

export default StoryblokBanner
